import { render } from "./Button.vue?vue&type=template&id=0f06bdbf&scoped=true&ts=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=0f06bdbf&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f06bdbf"]])

export default __exports__